import { Record } from 'immutable';

// ================================================================================================
// Identities Store
// ================================================================================================

export const IdentityVerificationStatusEnum = Object.freeze({
  NONE: 'NONE',
  PENDING: 'PENDING',
  INVALID: 'INVALID',
  VALID: 'VALID',
  DISABLED: 'DISABLED',
  DOCUMENT: 'DOCUMENT',
});
// eslint-disable-line no-undef

export const mkIdentity = Record({
  id: undefined,
  clientId: undefined,
  firstName: undefined,
  middleName: undefined,
  lastName: undefined,
  suffix: undefined,
  dateOfBirth: undefined,
  ssn: undefined,
  ssnEncrypted: undefined,
  emailId: undefined,
  phoneId: undefined,
  addressId: undefined,
  userProfileId: undefined,
  verificationStatus: IdentityVerificationStatusEnum.NONE,
  primary: undefined,
});
